// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".1f68285ae411777518d5510ce69bbbb783e1697f.chunk.js";
};